import { fetchApi } from 'api/fetchApi'
import { paths } from 'api/generated/user_settings'

type Method = paths['/settings/messenger_filter/settings']['get']
export type Result = Method['responses']['200']['schema']

export const fetchMessagesFilterApi = () =>
  fetchApi<Result>('/settings/messenger_filter/settings')
